import React from "react";
import { createRoot } from "react-dom/client";
import App from "./app/layout/App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ScrollToTop from "./app/layout/ScrollToTop";

// CSS
import "./app/layout/styles.css";
import "react-toastify/dist/ReactToastify.min.css";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

export const history = {
  push: (path) => window.location.href = `${path}`,
};

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <ScrollToTop>
      <ToastContainer autoClose={2000} position="top-right" />
      <App />
    </ScrollToTop>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
